import styled, { css } from 'styled-components';
import { mobile_xl } from '../../../global/mediaQueryMixin';

const Icon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px;
  cursor: pointer;
  :hover {
    background-color: var(--neutral-secondary);
    border-radius: var(--border-radius-full);
  }
  ${mobile_xl(css`
    :hover {
      background-color: transparent;
    }
  `)}
`;

const DropDiv = styled.div`
  .active-state {
    background-color: var(--neutral-secondary);
    border-radius: var(--border-radius-full);
  }
`;
export { Icon, DropDiv };
